import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

function _isMobile() {
	let flag = navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
		)
	if(flag==null){
		return;
	}
	if (flag.length > 0) {
		store.state.isMobile = true
	}
	return
}
_isMobile()


Vue.use(ElementUI)

import {
	BootstrapVue,
	BootstrapVueIcons
} from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
import components from './components'
Vue.use(components);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
new Vue({
	store,
	router,
	render: h => h(App)
}).$mount('#app')
